var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectedEreferrals = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.392,
    viewBox: "0 0 27.703 19.392",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M5.541,1.385H22.162A1.384,1.384,0,0,1,23.548,2.77V13.852h1.385V2.77A2.773,2.773,0,0,0,22.162,0H5.541A2.773,2.773,0,0,0,2.77,2.77V13.852H4.155V2.77A1.384,1.384,0,0,1,5.541,1.385M1.467,16.622H26.236a1.937,1.937,0,0,1-1.857,1.385H3.324a1.937,1.937,0,0,1-1.857-1.385M.831,15.237A.831.831,0,0,0,0,16.068a3.325,3.325,0,0,0,3.324,3.324H24.379A3.325,3.325,0,0,0,27.7,16.068a.831.831,0,0,0-.831-.831ZM14.952,9.1V8.733h-2.2a2.2,2.2,0,0,0-2.2,2.2,1.71,1.71,0,0,0,.508,1.3.632.632,0,0,1,.224.446.452.452,0,0,1-.451.451.375.375,0,0,1-.185-.043A4.486,4.486,0,0,1,8.363,9.1,4.026,4.026,0,0,1,12.389,5.07h2.562V3.606a.735.735,0,0,1,.435-.668.727.727,0,0,1,.787.124l3.66,3.294a.733.733,0,0,1,0,1.089l-3.66,3.294a.733.733,0,0,1-1.222-.544V9.1Z",
    fill: " #047bc1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectedEreferrals);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selected-ereferrals.87b436950545a9f5fb7f39bfb74d3eb9.svg";